import { render, staticRenderFns } from "./Tongzhi.vue?vue&type=template&id=d3b6178a&scoped=true"
import script from "./Tongzhi.vue?vue&type=script&lang=js"
export * from "./Tongzhi.vue?vue&type=script&lang=js"
import style0 from "./Tongzhi.vue?vue&type=style&index=0&id=d3b6178a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b6178a",
  null
  
)

export default component.exports